import React, { memo } from "react"
import Select from "react-select"
import PropTypes from "prop-types"

// Styles
import customStyles from "./styles"

const BlogSearch = props => {
  const { className, classNamePrefix, selectSearchKey, options, placeholder } = props

  return (
    <Select
      className={className}
      classNamePrefix={classNamePrefix}
      isClearable
      isSearchable
      onChange={selectSearchKey}
      options={options}
      styles={customStyles}
      placeholder={placeholder}
    />
  )
}

BlogSearch.propTypes = {
  className: PropTypes.string,
  classNamePrefix: PropTypes.string,
  selectSearchKey: PropTypes.func,
  options: PropTypes.array,
}

export default memo(BlogSearch)
